import axios from 'axios';

import * as types from './types';
import Api from '../../../../lib/api';
import Utils from '../../../../lib/utils';

export const setFetchingInsureds = (fetching) => {
  return {
    type: types.SET_FETCHING_INSUREDS,
    payload: fetching
  };
};

export const setInsuredsError = (error) => {
  return {
    type: types.SET_INSUREDS_ERROR,
    payload: error
  };
};

export const setInsuredsList = (list) => {
  return {
    type: types.SET_INSUREDS_LIST,
    payload: list
  };
};

export const setTotalAmountOfInsureds = (total) => {
  return {
    type: types.SET_TOTAL_AMOUNT_OF_INSUREDS,
    payload: total
  };
};

export const addInsuredsError = (error) => {
  return {
    type: types.SET_INSUREDS_ADD_ERROR,
    payload: error
  };
};

export const addInsuredsSuccess = () => {
  return {
    type: types.SET_INSUREDS_ADD_SUCCESS,
  };
};

export const addInsuredsFetching = () => {
  return {
    type: types.SET_INSUREDS_ADD_FETCHING,
  };
};


export const setShowModal = (status) => {
  return {
    type: types.SET_INSUREDS_SHOW_MODAL,
    payload: status
  };
};

export const fetchInsureds = (queryParams) => {
  return (dispatch, getState) => {
    const { login, localization } = getState();
    let {
      error10005,
      error10006,
      error10007,
      error10011,
      error10019,
      errorDefault,
      errorConnection,
    } = localization.strings.hcProfile.projects.actions;
    const token = login.authToken;
    let urlParameters = '';

    dispatch(setFetchingInsureds(true));
    dispatch(setTotalAmountOfInsureds(0));

    const { insuredsPerPage } = getState().insureds;

    if (queryParams) {
      if (!queryParams.pageNumber) {
        queryParams.pageNumber = 1;
      }
      queryParams.pageSize = insuredsPerPage;
    } else {
      queryParams = {
        pageNumber: 1,
        pageSize: insuredsPerPage
      };
    }

    let urlQuery = 'cf/insureds';

    if(queryParams.insuredName){
      queryParams.insuredName = encodeURIComponent( queryParams.insuredName)
    }
    urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;

    return Api.get(`${urlQuery}${urlParameters}`, token)
      .then(response => {
        const { success, totalCount, data } = response.data;

        let errorMsg = '';
        if (success) {
          dispatch(setTotalAmountOfInsureds(totalCount ? totalCount : 0));
          dispatch(setInsuredsList(data ? data : []));
        } else {
          switch (data.errorCode) {
            case 10005:
              errorMsg = error10005;
              break;
            case 10006:
              errorMsg = error10006;
              break;
            case 10007:
              errorMsg = error10007;
              break;
            case 10011:
              errorMsg = error10011;
              break;
            case 10019:
              errorMsg = error10019;
              break;
            default:
              errorMsg = errorDefault;
              break;
          }
          dispatch(setInsuredsError(errorMsg));
          dispatch(setTotalAmountOfInsureds(0));
        }
      })
      .catch(() => {
        dispatch(setInsuredsError(errorConnection));
      });
  };
};

export const sendInsureds = (input, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      error10000,
      error10001,
      error10003,
      error10005,
      error10006,
      error10007,
      error10025,
      errorDefault,
      errorConnection,
    } = localization.strings.certFocusProjects.errors;

    const errors = {
      10000: error10000,
      10001: error10001,
      10003: error10003,
      10005: error10005,
      10006: error10006,
      10007: error10007,
      100025: error10025,
    };

    dispatch(addInsuredsFetching());
    let list = getState().insureds.list;

    let targetInsuredIndex = null;

    if(input.insuredId) {
      let updateInsured = list.find((currentInsured, currentIndex) => {
        if (currentInsured.Id === input.insuredId) {
          targetInsuredIndex = currentIndex;
          return true;
        }
      });
      updateInsured = {
        ...updateInsured,
        InsuredName: input.insuredName,
        LegalName: input.legalName,
        Address: input.address1,
        Address2: input.address2,
        City: input.city,
        PostalCode: input.postalCode,
        StateId: input.stateId,
        CountryID: input.countryId,
        ContactName: input.contactName,
        ContactFax: input.contactFax,
        ContactPhone: input.contactPhone,
        ContactEmail: input.contactEmail,
        TaxID: input.taxId,
        OldTaxId: input.oldTaxId,
        Vendor: input.vendor,
        Note: input.note,
        HolderId: [input.holderId, ...input.childHolderIds],
        HolderName: [input.holderName, ...input.childHolderNames],
        stateName: [input.stateName],
        userId: input.userId,
        userEmail: input.userEmail,
      }
      list[targetInsuredIndex] = updateInsured;
    }

    let apiMethod;

    if (input.insuredId) {
      apiMethod = 'put';
    } else {
      apiMethod = 'post';
    }

    return Api[apiMethod](`cf/insureds`, input, authToken)
      .then(response => {
        const { success, data } = response.data;

        if (success) {
          dispatch(addInsuredsSuccess());
          if (callback) {
            dispatch(setInsuredsList(list ? list : []));
            callback(true, data)
          };
        } else {
          const errorMsg = errors[data.errorCode] || errorDefault;
          dispatch(addInsuredsError(errorMsg));
          if (callback) callback(false, null);
        }
      })
      .catch(() => {
        dispatch(addInsuredsError(errorConnection));
        if (callback) callback(false);
      });
  };
};

// Type Ahead and search
export const setTypeAheadFetching = () => ({
  type: types.SET_TYPE_AHEAD_INSURED_FETCHING
});
export const setTypeAheadResults = result => ({
  type: types.SET_TYPE_AHEAD_INSURED_SUCCESS,
  payload: result
});
export const setTypeAheadError = error => ({
  type: types.SET_TYPE_AHEAD_INSURED_ERROR,
  payload: error
});
export const resetTypeAheadResults = () => {
  return {
    type: types.RESET_TYPE_AHEAD_INSURED_RESULTS
  }
};

const CancelToken = axios.CancelToken;
let source = null;

export const fetchTypeAhead = (keywords) => {
  return (dispatch, getState) => {
    const { login, localization } = getState();
    const {
      errorConnection,
    } = localization.strings.common.typeAheadErrors;
    const token = login.authToken;

    dispatch(setTypeAheadFetching(true));

    // cancel current request if any
    if (source) {
      source.cancel("typeAheadCanceled");
      source = null;
    }
    // create new token
    if(!source){
      source = CancelToken.source();
    }

    const queryParams = {
      insuredName: keywords,
      pageSize: 15, //limit results to 15
      pageNumber: 1,
      orderBy: 'insuredName',
    };
    const urlParameters = Utils.getUrlParameters(queryParams);
    const urlQuery ='cf/insureds';
    //get subcontractors
    Api.get(`${urlQuery}${urlParameters}`, token, source.token)
      .then(response => {
        const { success, data } = response.data;
        source = null;

        if (success) {
          if(data.length > 0){
            dispatch(setTypeAheadResults(data ? data : []));
          }else{
            dispatch(setTypeAheadError('No results found.'));
          }
        } else {
          const errorMsg = getTypeAheadErrors(data.errorCode, localization);
          dispatch(setTypeAheadError(errorMsg));
        }
      })
      .catch((err) => {
        if(err.message !== 'typeAheadCanceled'){
          dispatch(setTypeAheadError(errorConnection));
        }
      });
  };
};
const getTypeAheadErrors = (errorCode, localization) => {
  let {
    error10005, error10006, error10007,
    error10011, error10019, errorDefault,
  } = localization.strings.common.typeAheadErrors;
  let errorMsg = '';

  switch(errorCode) {
    case 10005:
      errorMsg = error10005;
      break;
    case 10006:
      errorMsg = error10006;
      break;
    case 10007:
      errorMsg = error10007;
      break;
    case 10011:
      errorMsg = error10011;
      break;
    case 10019:
      errorMsg = error10019;
      break;
    default:
      errorMsg = errorDefault;
      break;
  }

  return errorMsg;
}

export const archiveInsured = (insuredId, archived, callback) => {
  return (dispatch, getState) => {
    const { authToken } = getState().login;
    let getInsured = null, targetInsuredIndex = null;
    let insurdList = getState().insureds.list;
    getInsured = insurdList.find((currentInsured, currentInsuredIndex) => {
      if (currentInsured.Id === insuredId) {
        targetInsuredIndex = currentInsuredIndex
        return true;
      }
    });
    getInsured = { ...getInsured, archive: archived };
    insurdList[targetInsuredIndex] = getInsured;
    const { totalAmountOfInsureds, } = getState().insureds;
    Api.post(`cf/insureds/archive`, { insuredId, archived }, authToken).then((response) => {  
      dispatch(setTotalAmountOfInsureds(totalAmountOfInsureds ? totalAmountOfInsureds : 0));
      dispatch(setInsuredsList(insurdList ? insurdList : []));    
      if (callback) callback(true);
    })
  }
}

export const fetchInsuredsByHolder = (queryParams) => {
  return (dispatch, getState) => {
    const { login, localization } = getState();
    const {
      errorConnection,
    } = localization.strings.common.typeAheadErrors;
    const token = login.authToken;

    dispatch(setTypeAheadFetching(true));

    // cancel current request if any
    if (source) {
      source.cancel("typeAheadCanceled");
      source = null;
    }
    // create new token
    if(!source){
      source = CancelToken.source();
    }

    let urlQuery = 'cf/insureds/holder';
    let urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;
    
    Api.get(`${urlQuery}${urlParameters}`, token, source.token)
      .then(response => {
        const { success, data } = response.data;
        source = null;
        if (success) {
          if(data.length > 0){
            dispatch(setTypeAheadResults(data ? data : []));
          }else{
            dispatch(setTypeAheadError('No results found.'));
          }
        } else {
          const errorMsg = getTypeAheadErrors(data.errorCode, localization);
          dispatch(setTypeAheadError(errorMsg));
        }
      })
      .catch((err) => {
        if(err.message !== 'typeAheadCanceled'){
          dispatch(setTypeAheadError(errorConnection));
        }
      });
  };
};

// search insured using navbar search 
export const searchInsureds = (searchInput) => ({
  type: types.SET_SEARCH_INSURED_TRUE,
  payload: searchInput
});

export const stopSearchingInsureds = () => ({
  type: types.SET_SEARCH_INSURED_FALSE
});

export const sendPQRequest = (projectInsuredPayload, callback) => {
  return (dispatch, getState) => {
    const { login, localization } = getState();
    const { authToken } = login;
    const errorConnection = localization.strings.projectInsureds.errors.connectionError;

    dispatch(setInsuredsError(null));
    return Api['put'](
      'cf/sendpqrequest',
      projectInsuredPayload,
      authToken
    )
      .then(response => {
        const { success } = response.data;
        if (success) {
          if (callback) callback(true);
        } else {
          if (callback) callback(false);
        }
      })
      .catch(error => {
        dispatch(setInsuredsError(errorConnection));
        if (callback) callback(false);
      });
  };
};